import App from './index';

export default {
  path: '/home/app',
  component: App
};
